module.exports = __webpack_public_path__ + "img/minus.264b3a15.svg";